import check_mobile from '../util/check-mobile';

import siema from '../components/siema';
import btnUp from '../components/btnUp';

export default {
    init() {
        if (check_mobile()) {
            document.body.classList.add('is-mobile');
        }

        siema();
        btnUp();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js